import TB from '@tiger/bridge';
import React, { useEffect } from 'react';
import { Navigate, Route } from 'react-router-dom';
import AnimatedRouter from 'components/AnimatedRouter';
import Card from 'components/Card';
import IBDisabledEntry from 'components/IBDisabledEntry';
import AchBank from 'components/vendor/ach/AchBank';
import ChooseBankCard from 'components/vendor/ach/ChooseBankCard';
import PlaidContinue from 'components/vendor/ach/PlaidContinue';
import UpdatePlaid from 'components/vendor/ach/UpdatePlaid';
import security from 'stores/security';
import AchLayout from './Ach';
import AchComplete from './Ach/Complete';
import AchConfirm from './Ach/Confirm';
import AchFill from './Ach/Fill';
import SelectWay from './SelectWay';
import WireLayout from './Wire';
import WireComplete from './Wire/Complete';
import WireDefault from './Wire/Default';
import './style.scss';

const Withdraw: React.FC = () => {
    const isIRA = security.isIRAAccount;

    useEffect(() => {
        TB.showOnlineChat(true, { page: 'Withdraw_page' });
    }, []);

    // ib用户访问则引导至官网获取IB的登录名字和密码去ib官网操作
    if (!security.isMarscoAccount) {
        return (
            <Card page>
                <IBDisabledEntry />;
            </Card>
        );
    }

    return (
        <Card page>
            <div className="withdraw-root">
                <AnimatedRouter component={null} timeout={300}>
                    <Route index element={<SelectWay isIRA={isIRA} />} />
                    <Route path="ach" element={<AchLayout />}>
                        <Route index element={<AchBank source="withdraw" isIRA={isIRA} />} />
                        <Route path="choose-bankcard" element={<ChooseBankCard source="withdraw" />} />
                        <Route path="plaid-continue" element={<PlaidContinue source="withdraw" />} />
                        <Route path="fill" element={<AchFill />} />
                        <Route path="update-plaid" element={<UpdatePlaid />} />
                        <Route path="confirm" element={<AchConfirm isIRA={isIRA} />} />
                        <Route path="complete" element={<AchComplete isIRA={isIRA} />} />
                        <Route path="*" element={<Navigate to="." replace />} />
                    </Route>
                    <Route path="wire" element={<WireLayout />}>
                        <Route index element={<WireDefault />} />
                        <Route path="complete" element={<WireComplete isIRA={isIRA} />} />
                        <Route path="*" element={<Navigate to="." replace />} />
                    </Route>
                    <Route path="*" element={<Navigate to="." replace />} />
                </AnimatedRouter>
            </div>
        </Card>
    );
};

export default Withdraw;
